const PLACEHOLDER = /\{(.*?)\}/g;
/**
 * This function accepts a string with placeholder tokens and replaces each with
 * the corresponding value from `values` object.
 * For example:
 * resolvePlaceholders('Hello {name}', { name: 'Alice' }) // "Hello Alice"
 */
function resolvePlaceholders(input, values) {
  return input.replace(PLACEHOLDER, (match, word) => {
    return values[word] != null ? String(values[word]) : match;
  });
}

/**
 * This function doesn't actually do anything besides a bit of string
 * interpolation. Importantly though, it serves as a way to "mark" user-facing
 * strings in the codebase, so they can be statically extracted and translated
 * offline.
 */
const t = (text, ...[values]) => {
  return values ? resolvePlaceholders(text, values) : text;
};

exports.t = t;
